define('model/outcome.model',['require','exports','module','fukit'],function(require, exports, module) {
  var BaseModel = require('fukit').BaseModel;

  var OutcomeModel = BaseModel.extend({
    radioRequests: {
      'models OutcomeModel': '@constructor',
    },

    urlRootTemplate: '/api/v1/compliance/outcome/:templateType',
  });

  module.exports = OutcomeModel;
});

